import { Helmet } from 'react-helmet-async';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { CouponStatus } from '../../constants/coupon';
import { useActivateCompanyCoupon, useGetCouponList } from '../../hooks/useCompany';
import { useDialogStore } from '../../stores/dialogStore';
import CouponDetailTab from './components/CouponDetailTab';
import CouponQRTab from './components/CouponQRTab';

const MyCouponDetailPage = () => {
  const { code } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const tab = new URLSearchParams(location.search).get('tab');
  const step = tab === '2' ? 2 : 1;

  const openDialog = useDialogStore((state) => state.openDialog);

  const { data: coupon, isPending } = useGetCouponList({ page: 1, limit: 1, code: code });
  const couponData = coupon?.Data.data?.[0];

  const { mutateAsync } = useActivateCompanyCoupon();

  const handleUseCoupon = async () => {
    try {
      const response = await mutateAsync({ code });
      if (response.Code === '20100') {
        navigate(`/my-coupon/${code}?tab=2`);
      }
    } catch (error) {
      console.error(error);
      openDialog({
        title: 'เกิดข้อผิดพลาด',
        message: error?.response?.data.Message || 'ไม่สามารถใช้คูปองได้',
        variant: 'error',
      });
    }
  };

  const handleConfirmUsed = () => {
    navigate('/my-coupon');
  };

  const handleClose = () => {
    if (couponData?.status.toLowerCase() === CouponStatus.WAITING) {
      navigate('/my-coupon');
    } else {
      navigate(`/my-coupon/${code}?tab=1`, { replace: true });
    }
  };

  return (
    <>
      <Helmet>
        <title>Caltex rewards | รายละเอียดคูปอง</title>
      </Helmet>
      {step === 1 && (
        <CouponDetailTab data={couponData} isPending={isPending} onUseCoupon={handleUseCoupon} />
      )}
      {step === 2 && (
        <CouponQRTab
          code={code}
          data={couponData}
          isPending={isPending}
          onClose={handleClose}
          onConfirm={handleConfirmUsed}
        />
      )}
    </>
  );
};

export default MyCouponDetailPage;
